// extracted by mini-css-extract-plugin
module.exports = {"link_icon":"sidebar_link_icon__2pkqn","activeLink":"sidebar_activeLink__3WPol","logout_container":"sidebar_logout_container__27LES"};